
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/know-your-soil",
      function () {
        return require("private-next-pages/know-your-soil.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/know-your-soil"])
      });
    }
  